export default "__VITE_ASSET__CQqgEVpO__"